import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useUserProfile } from '../components/common/hooks/useProfileQueries';

const VerificationBanner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.profile);
  const { isAuthenticated } = useSelector((state) => state.auth);

  useUserProfile({
    enabled: !!isAuthenticated,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });


  const isUnderReview = user?.status === 'INREVIEW';

  const isVerified = user?.status === 'ACTIVE';

  const isRejected = user?.status === 'REJECTED';

  if (user?.role !== 'SHIPPER') {
    return null;
  }

  if (isVerified) {
    return null;
  }

  if (isRejected) {
    return (
      <div className="verification-banner mb-0" onClick={() => navigate('/company-info')} style={{ cursor: 'pointer' }}>
        <div className="container p-0">
          <div className="alert-danger border-0 mb-0 py-3 px-3" style={{ backgroundColor: '#f8d7da', borderRadius: '8px' }}>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div className="d-flex align-items-center gap-3">
                <div className="verification-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#721c24" />
                  </svg>
                </div>
                <div>
                  <h6 className="mb-0 fw-semibold" style={{ color: '#721c24' }}>
                    Document Verification Failed!
                  </h6>
                  <p className="mb-0 small mt-1" style={{ color: '#721c24' }}>
                    Your uploaded documents were rejected. Please upload valid documents to continue.
                  </p>
                </div>
              </div>
              <button className="btn btn-sm btn-danger">
                <i className="fas fa-upload me-1"></i>
                Re-upload Documents
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isUnderReview) {
    return (
      <div className="verification-banner mb-0">
        <div className="container p-0">
          <div className="alert-info border-0 mb-0 py-3 px-3" style={{ backgroundColor: '#d1ecf1', borderRadius: '8px' }}>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div className="d-flex align-items-center gap-3">
                <div className="verification-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#0c5460" />
                  </svg>
                </div>
                <div>
                  <h6 className="mb-0 fw-semibold" style={{ color: '#0c5460' }}>
                    Verification Under Review
                  </h6>
                  <p className="mb-0 small mt-1" style={{ color: '#0c5460' }}>
                    your documents and information have been submitted successfully, status changed to awaiting approval.
                    You will be notified once the verification is complete.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }

  if (user?.status === 'PENDING') {
    return (
      <div className="verification-banner mb-0" onClick={() => navigate('/company-info')} style={{ cursor: 'pointer' }}>
        <div className="container p-0">
          <div className="alert-warning border-0 mb-0 py-3 px-3" style={{ backgroundColor: '#fff3cd', borderRadius: '8px' }}>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <div className="d-flex align-items-center gap-3">
                <div className="verification-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#856404" />
                  </svg>
                </div>
                <div>
                  <h6 className="mb-0 fw-semibold" style={{ color: '#856404' }}>
                    Complete Your Profile Verification
                  </h6>
                  <p className="mb-0 small mt-1" style={{ color: '#856404' }}>
                    Please upload your documents and information to verify your account.
                  </p>
                </div>
              </div>
              <button className="btn btn-sm btn-warning" style={{ color: '#856404', fontWeight: '500' }}>
                <i className="fas fa-upload me-1"></i>
                Upload Documents
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default VerificationBanner;